// extracted by mini-css-extract-plugin
module.exports = {"content":"_3uhDIaRCPjOULaEQFkEGpE","desktop-renderer":"_3_bn68rYnKLaGkeHIALQVI","mobile-renderer":"bYgZS_4WQg8ZuWZSeORXl"};